<template>
  <div class="rb-center-content">
    <div class="rb-guide-group">
      <h3>{{ data.title_color }}</h3>
      <div class="rb-guide-image">
        <img
          :src="data.image_color"
          :alt="data.title_color"
          class="lazyload"
          loading="lazy"
        />
      </div>
      <div class="rb-outro" v-html="data.body_color"></div>
    </div>
    <div class="rb-guide-group">
      <h3>{{ data.title_clarity }}</h3>
      <div class="rb-guide-image">
        <img
          :src="data.image_clarity"
          :alt="data.title_clarity"
          class="lazyload"
          loading="lazy"
        />
      </div>
      <div class="rb-outro" v-html="data.body_clarity"></div>
    </div>
    <div class="rb-guide-group">
      <h3>{{ data.title_carat }}</h3>
      <div class="rb-guide-image">
        <img
          :src="data.image_carat"
          :alt="data.title_carat"
          class="lazyload"
          loading="lazy"
        />
      </div>
      <div class="rb-outro" v-html="data.body_carat"></div>
    </div>
    <div class="rb-guide-group">
      <h3>{{ data.title_cut }}</h3>
      <div class="rb-guide-image">
        <img
          :src="data.image_cut"
          :alt="data.title_cut"
          class="lazyload"
          loading="lazy"
        />
      </div>
      <div class="rb-popup-outro" v-html="data.body_cut"></div>
    </div>
  </div>
</template>
<script>
/**
 * Static Popup
 *
 * @summary
 * Data is created through customizer
 *
 * @props
 * data: Object
 */
export default {
  props: {
    data: {
      type: Object,
    },
  },
};
</script>
